import styled from 'styled-components'

export const StyledUList = styled.ul`
    list-style: none;
`